// teachers/order-detail
import React, { useCallback, useState } from 'react';
import View from 'src/pages/teachers/orders/detail';
import AppRender from 'src/routes/app-render';
import { useForm } from 'src/hooks/use-form';
import { fuelsApi } from 'src/api/fuels/vm-view';
import useToast from 'src/utils/toast-utils';

const Page = () => {
  const { handleNavigate, itemNavigate } = useForm();
  const { toastError } = useToast()
  const [data, setData] = useState();
  // Memoize the API call function to avoid infinite loop
  const fetchData = useCallback(async () => {
    if(itemNavigate){
      fuelsApi.getDetail(
        itemNavigate, false,
        (result) => {
          setData(result);
        },
        () => {
          // Redirect to page not found
          toastError();
        },
      );
    }else{ 
      setData({});
    }
  }, []); // No dependencies, so this function will only be created once

  return (
    <AppRender apiCall={fetchData}>
      {data && <View onNavigate={handleNavigate} item={data} />}
    </AppRender>
  );
};

export default Page;
